import React from "react";

import { DateLiteral, useLocalization } from "@plex/culture-react";
import { DataTableDef, Overlay } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";
import styles from "ui/screens/plex-dictionary/index.module.scss";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { ITranslationHistoryState, ITranslationHistoryItem } from "../TranslationHistory.state";

export const TranslationsHistoryGrid: React.FC<{ state: ITranslationHistoryState }> = ({ state }) => {
  const { t } = useLocalization();

  const localizedValues = useLocalizedValues(() => ({
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch"),
    date: glossaryMessages.property("date"),
    author: glossaryMessages.property("author"),
    locale: glossaryMessages.property("locale"),
    industry: glossaryMessages.property("industry"),
    action: glossaryMessages.property("action"),
    translation: glossaryMessages.property("translation"),
    definition: glossaryMessages.property("definition")
  }));

  return (
    <>
      <Overlay show={state.isLoading} showSpinner />

      <DataTableDef<ITranslationHistoryItem>
        data={state.data ? state.data : []}
        keySelector={row => row.committedTime}
        emptyText={state.data ? localizedValues.refineSearch : localizedValues.startSearch}
      >
        <DataTableDef.Column<ITranslationHistoryItem> id="date" title={localizedValues.date} sortable valueSelector={row => row.committedTime}>
          {row => <DateLiteral value={new Date(row.committedTime)} options={{ datetime: "medium" }} />}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="author" title={localizedValues.author} sortable valueSelector={row => row.authorName}>
          {row => row.authorName}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="locale" title={localizedValues.locale} sortable valueSelector={row => row.locale}>
          {row => row.locale}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="industry" title={localizedValues.industry} sortable valueSelector={row => row.industry}>
          {row => row.industry}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="action" title={localizedValues.action} sortable valueSelector={row => t(row.action)}>
          {row => t(row.action)}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="translation" title={localizedValues.translation} sortable valueSelector={row => row.translation}>
          {row => <p className={styles.wrapText}>{row.translation}</p>}
        </DataTableDef.Column>
        <DataTableDef.Column<ITranslationHistoryItem> id="definition" title={localizedValues.definition} sortable valueSelector={row => row.definition}>
          {row => <p className={styles.wrapText}>{row.definition}</p>}
        </DataTableDef.Column>
      </DataTableDef>
    </>
  );
};
